import React from 'react';
import ClassicPanel from './ClassicPanel';
import MusicPanel from './MusicPanel';
import SocialsPanel from './SocialsPanel';
import FontPicker from './FontPicker';
import ColorPicker from './ColorPicker';
import ZoomControl from './ZoomControl';
import { useConfig } from '../../ConfigContext';
import { AddToCart } from './AddToCart';
import MultipleZoomControl from '../Preview/MultipleLayouts/MultipleZoomControl';
import GapControl from '../Preview/MultipleLayouts/GapControl';
import LayoutSetter from '../Preview/MultipleLayouts/LayoutSetter';
import PairControls from '../Preview/PairControls';
import PairPanel from './PairPanel';

export default function Controls() {
  const { general, setGeneralState, setSocialsState, socials } = useConfig();

  return (
    <div className="settings">
      <div className="w-full">
        <h2 className="text-xl font-bold mb-3">Navrhněte si vlastní desku</h2>

        {general.glassType === 'classic' && <ClassicPanel />}
        {general.glassType === 'pair' && <PairPanel />}
        {general.glassType === 'music' && <MusicPanel />}
        {general.glassType === 'socials' && <SocialsPanel />}

        {(general.glassType === 'socials' ||
          general.glassType === 'pair' ||
          general.glassType === 'classic' ||
          general.glassType === 'music') && (
          <>
            <FontPicker />
            <ColorPicker />
            <ZoomControl />
            <div className="w-full flex items-start">
              <button
                style={{
                  background: '#c70034',
                  marginTop: '20px',
                  textAlign: 'left',
                  display: general.imageSrc !== '' ? 'block' : 'none',
                }}
                onClick={() => {
                  // setGeneralState({ zoom: 1 });
                  setGeneralState({ imageSrc: '' });
                  setGeneralState({ croppedAreaPixels: null });
                }}
                className="submit-custom"
              >
                Smazat fotku
              </button>
            </div>
            <div className="w-full flex items-start">
              <button
                style={{
                  background: '#c70034',
                  marginTop: '20px',
                  textAlign: 'left',
                  display:
                    socials.profilePicture !== '' &&
                    socials.profilePicture !== null
                      ? 'block'
                      : 'none',
                }}
                onClick={() => {
                  setSocialsState({ zoom: 1 });
                  setSocialsState({ profilePicture: '' });
                  setSocialsState({ croppedAreaPixels: null });
                }}
                className="submit-custom"
              >
                Smazat profilovou fotku
              </button>
            </div>
            <AddToCart />
          </>
        )}

        {general.glassType === 'multiple' && (
          <>
            <LayoutSetter />
            <MultipleZoomControl />
            <GapControl />
            <FontPicker />
            <ColorPicker />
            <AddToCart />
          </>
        )}
      </div>
    </div>
  );
}
